import { Navigate, Outlet, useLocation } from "react-router-dom";
import {
  clearAuthAndRedirectToLogin,
  isOutSourcingPath,
  isOutSourcingUser,
  isSalesPath,
  isSalesRestrictedUser,
  isTelephonyOnlyPath,
  OUT_SOURCING_ANALYTICS_PATH,
  OUT_SOURCING_HOME,
  SALES_HOME,
  TELEPHONY_ONLY_HOME,
  useTelephonyOnlyUser,
} from "../utils/permissions";
import { hasEmailAccess, isRemoteEmailAccessLoaded, useEmailAccessConfig } from "../utils/emailAccessConfig";

const PrivateRoute = () => {
  const location = useLocation();
  const telephonyOnly = useTelephonyOnlyUser();
  useEmailAccessConfig();
  const loginRaw = localStorage.getItem("login");
  const login = loginRaw ? JSON.parse(loginRaw) === true : false;
  const token = localStorage.getItem("authToken");

  if (!token || !token.trim()) {
    if (login) {
      clearAuthAndRedirectToLogin();
      return null;
    }
    return <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />;
  }

  if (!login) {
    return <Navigate to={`${process.env.PUBLIC_URL}/login`} replace />;
  }

  // "LiveDemoAccessOnly" users may also open Demo Operations / lead detail, whatever their role
  if (hasEmailAccess("LiveDemoAccessOnly")) {
    const demoPaths = ["DemoOps", "DetailViewOps"].map((page) => `${process.env.PUBLIC_URL}/${page}`);
    if (demoPaths.some((path) => location.pathname === path || location.pathname.startsWith(`${path}/`))) {
      return <Outlet />;
    }
  }

  // Telephony-only users are kept on Logs/Countries/Dialer even when typing another URL
  if (telephonyOnly && !isTelephonyOnlyPath(location.pathname)) {
    return <Navigate to={TELEPHONY_ONLY_HOME} replace />;
  }

  // Outsourced agents are kept on Student profile / Telephony Logs / Countries / Dialer
  // (+ Analytics if allowlisted). Wait for adminEmailAccess.json before bouncing them off Analytics.
  if (
    isOutSourcingUser() &&
    location.pathname === OUT_SOURCING_ANALYTICS_PATH &&
    !isRemoteEmailAccessLoaded()
  ) {
    return null;
  }
  if (isOutSourcingUser() && !isOutSourcingPath(location.pathname)) {
    return <Navigate to={OUT_SOURCING_HOME} replace />;
  }

  if (isSalesRestrictedUser() && !isSalesPath(location.pathname)) {
    return <Navigate to={SALES_HOME} replace />;
  }

  return <Outlet />;
};

export default PrivateRoute;
